export const GET_TRANSACTION_PRICING_OFFER = gql`
    query GetTransactionOfferId($transactionOfferId: Int!) {
        getTransactionPricing(transactionOfferId: $transactionOfferId) {
            id
            offerName
            revenueShare
            additionalTariffCharges {
                id
                name
                type
                baseRate
                lowestRate
                highestRate
                fixedRate
            }
            compliancePricingCharges {
                id
                name
                type
                chargeType
                baseRate
                lowestRate
                highestRate
                fixedRate
            }
            transactionPricingCards {
                id
                name
                type
                cardCategory
                baseRate
                percentageBaseRate
                percentageLowestRate
                percentageHighestRate
                perItemBaseRate
                perItemLowestRate
                perItemHighestRate
                baseRatePercentage
            }
        }
    }
`;
